import { ColDef } from "ag-grid-enterprise";
import * as GridUtils from "../../utils/gridUtils";

// 列の定義
const commonSettings = { sortable: true };
const editedScheduleTimeStartSettings: ColDef = {
  width: 200,
  ...commonSettings,
  editable: true, // この列を編集可能にする
  filter: "agDateColumnFilter",
  filterParams: {
    comparator: GridUtils.dateComparator,
    inRangeInclusive: true,
    browserDatePicker: true,
  },
  cellEditor: "dateTimeEditor", // カスタムエディタを設定
};

const dateSettings: ColDef = {
  width: 110,
  sortable: true,
  floatingFilter: true,
  valueFormatter: GridUtils.formatDateWithWeekday,
  filter: "agDateColumnFilter",
  filterParams: {
    comparator: GridUtils.dateComparator,
    inRangeInclusive: true,
    browserDatePicker: true,
  },
};

/*
comparator
cellStyle
*/

export let columns: ColDef[] = [
  /*{ headerName: '', field: 'chkrow', checkboxSelection: true, headerCheckboxSelection: true, width: 50, sortable: true, sortingOrder: ['desc'] */
  {
    headerName: "",
    field: "chkrow",
    checkboxSelection: true,
    headerCheckboxSelection: true,
    width: 50,
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      if (nodeA.isSelected === nodeB.isSelected) {
        return 0;
      }
      if (nodeA.isSelected > nodeB.isSelected) {
        return -1;
      }
      return 1;
    },
    sortable: true,
  },
  {
    headerName: "状況",
    field: "proc_status",
    width: 70,
    valueFormatter: GridUtils.procStatusFormatter,
    cellStyle: GridUtils.procStatusCellSyle,
  },
  { headerName: "ID", field: "id", width: 60, sortable: true, rowDrag: true },
  {
    headerName: "緊急",
    field: "urgency_level",
    width: 60,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#FF3366", "black"),
    filter: "agSetColumnFilter",
    hide: false,
  },
  {
    headerName: "R",
    field: "ready",
    width: 60,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#49BEAA", "white"),
    filter: "agSetColumnFilter",
  },
  { headerName: "進捗", field: "mach_abbr_names", width: 120, sortable: true },
  {
    headerName: "機械",
    field: "mach_name",
    width: 100,
    filter: "agSetColumnFilter",
  },
  {
    headerName: "機械作業コード",
    field: "mach_code",
    width: 100,
    sortable: true,
    hide: false,
  },
  { headerName: "強化基準日", field: "proc_date", ...dateSettings },
  {
    headerName: "編集(開始時刻)",
    field: "edited_schedule_time_start",
    ...commonSettings,
    ...editedScheduleTimeStartSettings,
    hide: true,
  },
  {
    headerName: "編集(終了時刻)",
    field: "edited_schedule_time_end",
    width: 180,
    sortable: true,
    hide: true,
  },
  {
    headerName: "加工順",
    field: "proc_order",
    sortable: true,
    width: 120,
    editable: true,
    filter: "agSetColumnFilter",
    comparator: GridUtils.numericComparatorWithNullsLast,
    hide: true,
  },
  {
    headerName: "計画済",
    field: "is_fin_proc_schedule_complete",
    width: 85,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#F9C748", "white"),
    hide: true,
  },
  {
    headerName: "送り先名",
    field: "destin_name",
    filter: "agTextColumnFilter",
    sortable: true,
  },
  { headerName: "得意先名", field: "customer_name", sortable: true },
  { headerName: "出荷日", field: "ship_date", ...dateSettings },
  { headerName: "着日", field: "arrival_date", ...dateSettings },
  {
    headerName: "注文NO",
    field: "po_data_num",
    width: 125,
    cellStyle: { fontSize: "10px" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    headerName: "受注ＮＯ",
    field: "po_desc_num",
    width: 120,
    cellStyle: { fontSize: "10px" },
    filter: "agTextColumnFilter",
  },
  {
    headerName: "計画日時",
    field: "schedule_start_time",
    width: 180,
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    headerName: "加工時間",
    field: "simulated_proc_time",
    width: 80,
    sortable: true,
  },
  { headerName: "板厚", field: "thickness", width: 80, sortable: true },
  { headerName: "板種", field: "sheet_type", width: 110, sortable: true },
  { headerName: "商品名", field: "product_name", width: 150, sortable: true },
  { headerName: "W", field: "po_width", width: 80, sortable: true },
  { headerName: "H", field: "po_height", width: 80, sortable: true },
  { headerName: "現数", field: "current_qty", width: 80, sortable: true },
  {
    headerName: "物件名",
    field: "project_name",
    width: 160,
    filter: "agTextColumnFilter",
  },
  {
    headerName: "ソ",
    field: "has_soak",
    width: 80,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#F9C748", "white"),
    filter: "agSetColumnFilter",
  },
  {
    headerName: "合",
    field: "has_lam",
    width: 80,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#F9C748", "white"),
    filter: "agSetColumnFilter",
  },
  {
    headerName: "複",
    field: "has_ig",
    width: 80,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#F9C748", "white"),
    filter: "agSetColumnFilter",
  },
  {
    headerName: "フ",
    field: "has_film",
    width: 80,
    sortable: true,
    cellStyle: GridUtils.highlightIfOneWithColor("#F9C748", "white"),
    filter: "agSetColumnFilter",
  },
  { headerName: "原価リミット", field: "cost_limit", width: 100 },
  { headerName: "レシピ", field: "recipe_id", width: 80 },
  { headerName: "レシピ名", field: "recipe_name", width: 180 },
  { headerName: "強CT", field: "tempering_cycle_time", width: 100 },
  {
    headerName: "レシピ関数",
    field: "evaluate_fn_string",
    width: 100,
    hide: true,
  },
  {
    headerName: "データ作成時刻",
    field: "order_data_created_at",
    width: 200,
    filter: "agTextColumnFilter",
    sortable: true,
  },
];
